import { useEffect, useState } from 'react'

const useUUID = () => {
  const [uuid, setUuid] = useState('')

  useEffect(() => {
    const { pathname } = window.location
    const clearPathname = pathname.replace('/', '')
    const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(clearPathname)

    if (isUuid) {
      setUuid(clearPathname)
    }
  }, [])

  return uuid
}

export default useUUID
